import { Typography } from '@components';
import React from 'react';

type ImageProps = {
  imageUrl: string;
  text: string;
};

export const OverviewImage = ({ imageUrl, text }: ImageProps) => {
  return (
    <div className="flex flex-col items-center my-auto mx-auto">
      <img
        src={imageUrl}
        alt="Overview Image"
        className="h-36 w-auto mr-3 mt-5 mb-2 rounded-md"
      />
      <div className="mb-3">
        <Typography tag="p" color="noColor" type="semibold">
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default OverviewImage;
